export const BottomNavigationTabArray = ['song', 'library', 'youtube', 'quiz', 'other'];
export type BottomNavigationTabType = typeof BottomNavigationTabArray[number];
